// extracted by mini-css-extract-plugin
module.exports = {"flex-container":"DrugInfoEntry_flex-container__YOKWe","error":"DrugInfoEntry_error__2cOFv","section-label":"DrugInfoEntry_section-label__dreqR"};